import { render, staticRenderFns } from "./base_aggregator.vue?vue&type=template&id=ef6c638a&scoped=true&"
import script from "./base_aggregator.vue?vue&type=script&lang=js&"
export * from "./base_aggregator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6c638a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef6c638a')) {
      api.createRecord('ef6c638a', component.options)
    } else {
      api.reload('ef6c638a', component.options)
    }
    module.hot.accept("./base_aggregator.vue?vue&type=template&id=ef6c638a&scoped=true&", function () {
      api.rerender('ef6c638a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/base/base_aggregator.vue"
export default component.exports